import React, { useState, useEffect } from "react";
import instance from "../../instance";

import "../Customer.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BackupDetails = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const code = params.get("code");

  const [backupData, setBackupData] = useState(null);
  const [isEditingBackup, setIsEditingBackup] = useState(false);
  const [backupFormData, setBackupFormData] = useState({
    BackupAuto: "",
    BackupManualMaxNumber: "",
    BackupManualPath: "",
    BackupAutoPath: "",
  });

  useEffect(() => {
    if (code) {
      fetchBackupData();
    } else {
      toast.error("No code provided.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchBackupData is recreated each render; adding it would refetch on every paint
  }, [code]);

  const fetchBackupData = async () => {
    try {
      const response = await instance.get(`backup/by-code/${code}`);
      if (response.status !== 200) {
        throw new Error("Failed to fetch backup data.");
      }
      const data = response.data;
      if (data && data.data) {
        setBackupData(data.data);
        setBackupFormData({
          BackupAuto: data.data.BackupAuto || "",
          BackupManualMaxNumber: data.data.BackupManualMaxNumber || "",
          BackupManualPath: data.data.BackupManualPath || "",
          BackupAutoPath: data.data.BackupAutoPath || "",
        });
      } else {
        toast.error("No backup data found for the given code.");
      }
    } catch (error) {
      console.error("Error fetching backup data:", error);
      toast.error("An error occurred while fetching backup data.");
    }
  };

  const toggleEditBackup = () => {
    if (isEditingBackup) {
      saveBackupData();
    } else {
      setIsEditingBackup(true);
    }
  };

  const handleBackupInputChange = (event) => {
    const { id, value } = event.target;
    setBackupFormData({ ...backupFormData, [id]: value });
  };

  const saveBackupData = () => {
    instance
      .put(`backup/by-code/${code}`, backupFormData, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success("Backup details updated successfully!");
        fetchBackupData();
        setIsEditingBackup(false);
      })
      .catch((error) => {
        console.error("Error updating backup details:", error);
        toast.error("An error occurred while updating backup details.");
      });
  };

  return (
    <div>
      <main>
        <section id="backup-section">
          <h2>Backup Details</h2>
          {backupData && (
            <ul>
              <li>
                Backup Auto:{" "}
                <span
                  className={`info ${isEditingBackup ? "hidden" : ""}`}
                  id="info-BackupAuto"
                >
                  {backupData.BackupAuto}
                </span>
                {isEditingBackup && (
                  <input
                    className="input-field"
                    type="text"
                    id="BackupAuto"
                    value={backupFormData.BackupAuto}
                    onChange={handleBackupInputChange}
                    placeholder="Enter Backup Auto"
                  />
                )}
              </li>
              <li>
                Backup Manual Max Number:{" "}
                <span
                  className={`info ${isEditingBackup ? "hidden" : ""}`}
                  id="info-BackupManualMaxNumber"
                >
                  {backupData.BackupManualMaxNumber}
                </span>
                {isEditingBackup && (
                  <input
                    className="input-field"
                    type="text"
                    id="BackupManualMaxNumber"
                    value={backupFormData.BackupManualMaxNumber}
                    onChange={handleBackupInputChange}
                    placeholder="Enter Backup Manual Max Number"
                  />
                )}
              </li>
              <li>
                Backup Manual Path:{" "}
                <span
                  className={`info ${isEditingBackup ? "hidden" : ""}`}
                  id="info-BackupManualPath"
                >
                  {backupData.BackupManualPath}
                </span>
                {isEditingBackup && (
                  <input
                    className="input-field"
                    type="text"
                    id="BackupManualPath"
                    value={backupFormData.BackupManualPath}
                    onChange={handleBackupInputChange}
                    placeholder="Enter Backup Manual Path"
                  />
                )}
              </li>
              <li>
                Backup Auto Path:{" "}
                <span
                  className={`info ${isEditingBackup ? "hidden" : ""}`}
                  id="info-BackupAutoPath"
                >
                  {backupData.BackupAutoPath}
                </span>
                {isEditingBackup && (
                  <input
                    className="input-field"
                    type="text"
                    id="BackupAutoPath"
                    value={backupFormData.BackupAutoPath}
                    onChange={handleBackupInputChange}
                    placeholder="Enter Backup Auto Path"
                  />
                )}
              </li>
            </ul>
          )}
          <button className="edit-button" onClick={toggleEditBackup}>
            {isEditingBackup ? "Save" : "Update"}
          </button>
        </section>
      </main>
    </div>
  );
};

export default BackupDetails;
